import { LayoutModule } from '@angular/cdk/layout';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import {
  FaIconLibrary,
  FontAwesomeModule
} from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicRouteStrategy } from '@ionic/angular';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { CoreModule } from './core/core.module';
import { AuthModule } from './features/auth/auth.module';
import { IndexModule } from './features/index/index.module';
import { SharedModule } from './features/shared/shared.module';
import { UserManagementModule } from './features/user-management/user-management.module';
import { Actions, ofType } from '@ngrx/effects';
import {
  StartNotifications,
  ENotificationsActions,
  ListNotifications,
  StopNotifications
} from '@eview/core/store/actions/notifications.actions';
import { environment } from '@eview/core';
import { Store, StoreRootModule } from '@ngrx/store';
import { AppState } from '@eview/core/store/states/app.state';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { AppLoadingModule } from '@eview/core/loading/app-loading.module';

// const config =

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    NgbModule,
    FontAwesomeModule,
    NgbNavModule,
    IndexModule,
    UserManagementModule,
    RecaptchaV3Module,
    AppLoadingModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    SplashScreen,
    StatusBar,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.authentication.token_ga_web, // Reemplaza con tu clave de sitio
    }, 
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ]
})

export class AppModule {
  constructor(
    library: FaIconLibrary,
    actions$: Actions,
    store: Store<AppState>
  ) {
    library.addIconPacks(fas);
    this.handleNotifications(actions$, store);
  }

  private handleNotifications(actions$, store) {
    let notificationsTimer = null;
    actions$
      .pipe(
        ofType<StartNotifications>(ENotificationsActions.StartNotifications)
      )
      .subscribe(() => {
        if (notificationsTimer) clearInterval(notificationsTimer);
        if (
          environment.notifications.enabled &&
          environment.notifications.timing > 0
        ) {
          notificationsTimer = setInterval(() => {
            store.dispatch(new ListNotifications());
          }, environment.notifications.timing * 1000 || 1000);
        }
      });
    actions$
      .pipe(ofType<StopNotifications>(ENotificationsActions.StopNotifications))
      .subscribe(() => {
        if (notificationsTimer) clearInterval(notificationsTimer);
      });
  }
}
